// extracted by mini-css-extract-plugin
export var footer = "_o0-5";
export var fulfillmentInput = "_o0-0";
export var shipDateInput = "_o0-1";
export var shipmentModal = "_o0-2";
export var shipmentModalContent = "_o0-3";
export var tableContainer = "_o0-4";